import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createVNode(_component_NcNoteCard, {
      type: _ctx.sconfig.albums_enabled ? 'success' : 'warning'
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sconfig.albums_enabled
          ? _ctx.t('memories', 'Albums support is enabled through the Photos app.')
          : _ctx.t('memories', 'Albums are disabled because the Photos app is not available.')), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_component_NcNoteCard, {
      type: _ctx.sconfig.recognize_enabled ? 'success' : 'warning'
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sconfig.recognize_enabled
          ? _ctx.t('memories', 'Recognize is installed and enabled for face recognition.')
          : _ctx.sconfig.recognize_installed
            ? _ctx.t('memories', 'Recognize is installed but not enabled for face recognition.')
            : _ctx.t('memories', 'Recognize is not installed. Face recognition and object tagging may be unavailable.')), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    (_ctx.sconfig.facerecognition_installed)
      ? (_openBlock(), _createBlock(_component_NcNoteCard, {
          key: 0,
          type: "success"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('memories', 'Face Recognition is installed and enabled')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_NcNoteCard, {
      type: _ctx.sconfig.preview_generator_enabled ? 'success' : 'error'
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sconfig.preview_generator_enabled
          ? _ctx.t('memories', 'Preview generator is installed and enabled. Additional configuration may still be required.')
          : _ctx.t('memories', 'Preview generator is not installed and configured. This may make Memories very slow.')), 1)
      ]),
      _: 1
    }, 8, ["type"])
  ]))
}